import { useContext, useState } from "react";
import { PorfolioContainer } from "./styled";
import { shortenAddress } from "../../../utils/addressUser";
import { ContextProviderWrapper } from "../../../components/Context";
import { convertFixed, convertFromWei } from "../../../utils/convertNumber";
import { getTokenInfoBySymbol } from "../../../utils/tokenUtils";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
// import { getTokenAddressBySymbol } from "../../../utils/tokenUtils";

export const Porfolio = ({
  balance,
  currentChain,
  setTotalBalanceWallet,
}: any) => {
  const [expanded, setExpanded] = useState(false);
  const { theme } = useContext(ContextProviderWrapper)!;
  const dataBalanceWallets = balance?.wallets?.[0]?.balances || [];
  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  const chainRouter = currentChain;
  const chainId = (() => {
    switch (chainRouter) {
      case "Avalanche":
        return 43114;
      case "Solana":
        return 101;
      case "Toncoin":
        return 396;
      default:
        return 43114;
    }
  })();

  const handleChangeLink = (address: any) => {
    switch (chainRouter) {
      case "Avalanche":
        return `https://snowscan.xyz/address/${address}`;
      case "Toncoin":
        return `https://tonscan.org/jetton/${address}`;
      case "Solana":
        return `https://solscan.io/token/${address}`;
    }
  };

  const visibleTokens =
    balance && expanded
      ? dataBalanceWallets.filter((token: any) => token.price != null)
      : dataBalanceWallets
          .filter((token: any) => token.price != null)
          .slice(0, 5);

  //get current chain
  const getChainIcon = (chainName: string) => {
    switch (chainName) {
      case "Avalanche":
        return "/assets/images/icons/icn_avax.svg";
      case "Solana":
        return "/assets/images/icons/icn_solana.svg";
      case "Toncoin":
        return "/assets/images/icons/icn_ton.svg";
      default:
        return "/assets/images/icons/icn_avax.svg";
    }
  };

  //total USD
  const totalUsd = dataBalanceWallets
    .filter((token: any) => token.price != null)
    .reduce((sum: number, token: any) => {
      const amount = Number(
        convertFromWei(token.amount.amount, token.amount.decimals)
      );
      return sum + amount * Number(token.price);
    }, 0);
  setTotalBalanceWallet(totalUsd);

  return (
    <PorfolioContainer className={theme}>
      <div className="list-token">
        {visibleTokens?.map((item: any, index: number) => {
          const tokenInfo = getTokenInfoBySymbol(item.asset?.symbol || "");
          return (
            <div className="item-token" key={index}>
              <div className="block-token">
                <div className="icon-token">
                  <img
                    src={
                      item.asset?.address
                        ? `https://static.cx.metamask.io/api/v1/tokenIcons/${chainId}/${item.asset.address}.png`
                        : tokenInfo.image
                    }
                    width={32}
                    height={32}
                    loading="lazy"
                    alt={item.symbol}
                  />
                </div>
                <div className="icon-chain">
                  <img
                    src={getChainIcon(currentChain)}
                    width={16}
                    height={16}
                    loading="lazy"
                    alt="Chain"
                  />
                </div>
              </div>
              <div className="detail-token">
                <h3 className="name-token">
                  <span className="sysbol">{item.asset.symbol}</span>
                  {/* <span className="name">{item.name}</span> */}
                </h3>
                <div className="amount-token">
                  <span>
                    <span className="amount">
                      {convertFixed(
                        Number(
                          convertFromWei(
                            item.amount.amount,
                            item.amount.decimals
                          )
                        )
                      )}
                    </span>
                    {/* <span className="percent">{item.percent}</span> */}
                  </span>
                </div>
                <div className="price-token">
                  <span className="usd-price">
                    $
                    {(
                      Number(item.price) *
                      Number(
                        convertFromWei(item.amount.amount, item.amount.decimals)
                      )
                    ).toFixed(2)}
                  </span>
                  {/* <span className="eth-value">{item.ethValue}</span> */}
                </div>
                <div className="address-token">
                  <span className="address">
                    {shortenAddress(item.asset?.address || tokenInfo.address)}
                  </span>
                  <div className="action">
                    <CopyToClipboard
                      text={item.asset?.address}
                      onCopy={() => {
                        toast.success("Copied !!");
                      }}
                    >
                      <div className="copy trans">
                        <img
                          src="/assets/images/profile/icn_copy.svg"
                          width={16}
                          height={16}
                          loading="lazy"
                          alt="Copy"
                        />
                      </div>
                    </CopyToClipboard>

                    <div className="arrow trans">
                      <Link
                        to={`${handleChangeLink(item.asset?.address)}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src="/assets/images/profile/icn_arrow_right.svg"
                          width={16}
                          height={16}
                          loading="lazy"
                          alt="Arrow"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {dataBalanceWallets?.length > 5 && !expanded && (
          <div className="unfold-button" onClick={handleToggle}>
            Unfold all
          </div>
        )}

        {dataBalanceWallets?.length > 5 && expanded && (
          <div className="unfold-button" onClick={handleToggle}>
            Collapse
          </div>
        )}
      </div>
    </PorfolioContainer>
  );
};

export default Porfolio;
